import CSSTransitionGroup from "react-addons-css-transition-group";
import VideoContainer from "containers/VideoContainer";
import ImageContainer from "containers/ImageContainer";
import InnerUIContainer from "components/InnerUIContainer";
import PropTypes from "prop-types";
import React from "react";
import ViewStoryButton from "components/ViewStoryButton";
import styles from "./ChapterCoverComponentStyles.css";

export default function ChapterCoverComponent(props) {
  return (
    <div aria-label="Chapter Cover" className={styles.root} role="group">
      <CSSTransitionGroup
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        transitionName={{
          enter: styles.transitionEnter,
          enterActive: styles.transtionEnterActive,
          leave: styles.transitionLeave,
          leaveActive: styles.transitionLeaveActive,
        }}
      >
        {props.showPoster && (
          <div className={styles.image} key="chapter-cover-image">
            <ImageContainer contain={false} imageId={props.thumbnailId} />
          </div>
        )}
      </CSSTransitionGroup>
      <VideoContainer
        active
        allowDurationChange={false}
        alwaysAutoplay
        autoplay
        disableAds={props.disableAds}
        disableContain
        forceMute
        loop
        onUserInteractionInitiatedPlayback={
          props.onUserInteractionInitiatedPlayback
        }
        playbackStarted
        stateKey={props.stateKey}
        useFocalPoint
        videoId={props.videoId}
      />
      <div className={styles.bottomGradient} />
      {props.showClickArea && (
        <InnerUIContainer
          alwaysAssumeNavIsHidden
          onClick={props.onReceivedUserInteraction}
        >
          <div className={styles.buttonContainer}>
            <ViewStoryButton
              onClick={props.onReceivedUserInteraction}
              showBackgroundColor
              text={props.chapterTitle}
            />
          </div>
        </InnerUIContainer>
      )}
    </div>
  );
}

ChapterCoverComponent.propTypes = {
  adRequiresDirectUserInteraction: PropTypes.bool.isRequired,
  callToAction: PropTypes.string.isRequired,
  chapterTitle: PropTypes.string.isRequired,
  disableAds: PropTypes.bool.isRequired,
  onReceivedUserInteraction: PropTypes.func.isRequired,
  onUserInteractionInitiatedPlayback: PropTypes.func.isRequired,
  receivedUserInteraction: PropTypes.bool.isRequired,
  showCallToAction: PropTypes.bool.isRequired,
  showClickArea: PropTypes.bool.isRequired,
  showCoverTitle: PropTypes.bool.isRequired,
  showPoster: PropTypes.bool.isRequired,
  stateKey: PropTypes.string.isRequired,
  thumbnailId: PropTypes.number.isRequired,
  usePersistentVideo: PropTypes.bool.isRequired,
  videoId: PropTypes.number.isRequired,
};
